<template>
  <!-- Importing Page not found Component -->
  <PageNotFound></PageNotFound>
</template>
<script>
import PageNotFound from "../../components/Error/NotFound.vue";

export default {
  name: "Not Found",
  components: { PageNotFound },
  computed: {},
  mounted() {},
};
</script>
